var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(_vm._s((_vm.Value != undefined && _vm.Value.trim()) ? _vm.Value : "-"))])
}
var staticRenderFns = []

export { render, staticRenderFns }